"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
function CatalogChips() {
    const data = (0, react_redux_1.useSelector)(selectors_1.selectCatalogSeriesType);
    const currentSeries = (0, react_redux_1.useSelector)(selectors_1.selectCatalogSeries);
    const currentCategoryGroup = (0, react_redux_1.useSelector)(selectors_1.selectCatalogCategoryGroup);
    const { dispatchSetCatalogSeries } = (0, redux_1.bindActionCreators)({
        dispatchSetCatalogSeries: actions_1.setCatalogSeries,
    }, (0, react_redux_1.useDispatch)());
    if (!data || !data.series || currentCategoryGroup) {
        return null;
    }
    return (react_1.default.createElement(UI_1.Chips, { chips: data.series.map((series) => ({
            label: series.name,
            id: series.id,
            value: series,
        })), selected: currentSeries, onChange: dispatchSetCatalogSeries }));
}
exports.default = CatalogChips;
